import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class ElectionAuditChannelSubscription {
  public subscription: Subscription;

  constructor(electionAuditId: number, { received, connected = undefined, disconnected = undefined }) {
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: "ElectionAuditChannel",
        election_audit_id: electionAuditId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}
